import MultiCurrency from '@/classes/currencies/MultiCurrency'
import SportingStatistics from '@/classes/statistics/SportingStatistics'

export default class Statistics {
  constructor ({ amount_collected = {}, contributions_count = { total: 0 }, sporting_statistics = {}, ...statistics } = {}) {
    this.amount_collected = new MultiCurrency(amount_collected)
    this.contributions_count = contributions_count.total
    this.sporting_statistics = new SportingStatistics(sporting_statistics)

    Object.assign(this, statistics)
  }
}
